import { Avatar } from "@material-ui/core";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Box,
  IconButton,
  Link,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import isoCountries from "i18n-iso-countries";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import "../../App.css";
import CommonUtil from "../../Util/CommonUtils";
import {
  REACT_CREATE_DEALER,
  REACT_DASHBOARD_PANEL,
} from "../../actions/EndPoints";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { exportDealerLogs } from "../../services/Invitations/ExportDealerService";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import { postChildSwitchCompany } from "../../slices/DashboardPanel/DashboardPanelSlice";
import {
  getDealerBillingInfo,
  getDealerInvoice,
  getDealers,
  resendActivationLinkForDealer,
} from "../../slices/Dealer/DealerSlice";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import CustomerIcon from "../Customer/CustomerIcon";
import ExportDialog from "../DailyReports/ExportDialog";
import ResendIcon from "../Invitations/ResendIcon";
import ViewIcon from "../Invitations/ViewIcon";
import EditIcon from "../Person/EditIcon";
import CreateDealer from "./CreateDealer";
import DealerFilter from "./DealerFilter";
import DeleteDealer from "./DeleteDealer";
import ImpersonationIcon from "./ImpersonationIcon";
import InvoiceIcon from "./InvoiceIcon";

export default function Dealer() {
  const history = useHistory();
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [open, setOpen] = useState(false);
  const [openEditDealer, setOpenEditDealer] = useState(false);
  const [clear, setClear] = React.useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [selectedData, onSelectionChange] = useState([]);
  const [pageSize, setPageSize] = useState(0);
  const [openDeleteDealer, setOpenDeleteDealer] = useState(false);
  const [dealerId, setDealerId] = useState();
  const [dealer, setDealer] = useState();
  const [dealerName, setDealerName] = useState();
  const [editRowData, setEditRowDate] = useState({});
  const [editDealerPage, setEditDealerPage] = useState(false);
  const [parentCompanyCountry, setParentCompanyCountry] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedObject, setSelectedObject] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
    companyCode: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    postCode: "",
    profile: "",
  });

  const [filter, setFilter] = React.useState({
    status: "",
    name: "",
    email: "",
    type: "PARTNER",
  });

  const [fileFormat, setFileFormat] = useState("1");
  const [noOfRecords, setNoOfRecords] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [isLivePhoto, setIsLivePhoto] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [closemodel, setClosemodel] = useState(false);
  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const defaultFilter = {
    status: "",
    name: "",
    email: "",
    type: "PARTNER",
  };

  const applyFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      status: data.status,
      name: data.name,
      email: data.email,
      type: "PARTNER",
    });
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
    setLoading(true);
  };

  useEffect(() => {
    loadParentCompany();
  }, []);

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleChange = (newPage, size) => {
    setLoading(true);
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  const handleFileFormatChange = (event) => {
    setFileFormat(event.target.value);
  };

  const handleDataRecordsChange = (event) => {
    setNoOfRecords(event.target.value);
  };

  const handleCheckBoxLivePhoto = (event) => {
    setIsLivePhoto(event.target.checked);
  };
  const handleCheckBoxSignature = (event) => {
    setIsSignature(event.target.checked);
  };
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setInputValue(value);
    }
  };

  const handleToInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setToInputValue(value);
    }
  };

  const handleExportCustomer = (data) => {
    if (fileFormat == "2") {
      setIsLivePhoto(false);
      setIsSignature(false);
    }
    var searchParam = "";
    if (filter.name !== undefined && !CommonUtil.isEmptyString(filter.name)) {
      searchParam += "&name=" + encodeURIComponent(filter.name);
    }
    if (filter.email !== undefined && !CommonUtil.isEmptyString(filter.email)) {
      searchParam += "&email=" + encodeURIComponent(filter.email);
    }
    if (filter.type !== undefined && !CommonUtil.isEmptyString(filter.type)) {
      searchParam += "&type=" + filter.type;
    }
    if (
      filter.status !== undefined &&
      !CommonUtil.isEmptyString(filter.status)
    ) {
      searchParam += "&status=" + filter.status;
    }
    searchParam += "&isDealer=" + "isDealer";

    const stats = {
      fileType: fileFormat,
      from: inputValue === "" ? "0" : inputValue,
      to: toInputValue === "" ? "0" : toInputValue,
    };

    dispatch(exportDealerLogs(onSuccess, onFailure, stats, searchParam))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((er) => { });
  };

  const onSuccess = () => {
    setClosemodel(true);

    return Toast(t("EXPORTSUCC001"), "success");
  };

  const onFailure = () => {
    Toast(t("COMMON000"), "error");
  };

  const handleOpen = () => {
    setOpen(true);
    history.push({
      pathname: REACT_CREATE_DEALER,
      country: parentCompanyCountry,
    });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 15) {
      return text.substring(0, 17) + "...";
    } else {
      return text;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(getDealers(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4007") {
          setLoading(false);
          setTotalRecords(data.data.totalCount);
          setRows(data.data.companies);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const loadParentCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setParentCompanyCountry(countryCode);
          }
        }
      })
      .catch((er) => { });
  };

  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const handleOpenEditDealer = (params) => {
    setEditRowDate(params);
    setEditDealerPage(true);
    dispatch(getDealerBillingInfo(params.id))
      .unwrap()
      .then((data) => {
        history.push({
          pathname: REACT_CREATE_DEALER,
          state: {
            params: params,
            billingInfo: data.data,
          },
          country: parentCompanyCountry,
        });
      })
      .catch((e) => { });
  };

  const handleView = (params) => {
    history.push({
      pathname: "/vis/viewDealerDetails",
      state: params,
    });
  };

  const handleDeleteDealers = (params) => {
    setOpenDeleteDealer(!openDeleteDealer);
    setDealerId(params.id);
    setDealer(params);
    setDealerName(params.name);
  };

  const handleResendAccountActivate = (params) => {
    dispatch(resendActivationLinkForDealer(params))
      .unwrap()
      .then((data) => {
        switch (data.code) {
          case "MSGS4015":
            Toast(t("DEALERRESENDACTIVEEMAIL"), "success");
            break;
          case "MSGE4006":
            Toast(t("DEALERCHECKACTIVEEMAILNOT"), "error");
            break;
          default:
            Toast(data.message, "error");
            break;
        }
      })
      .catch((e) => { });
  };

  const handleViewCustomer = (params) => {
    history.push({
      pathname: "/vis/dealerCustomersReport",
      state: params,
    });
  };

  const handleImpersonation = (params) => {
    if (params.row.status === "INACTIVE") {
      return Toast(t("IMPERSONATION_ERROR"), "error");
    }
    const payload = {
      companyId: params.row.id,
      impersonatingCompanyName: params.row.name,
      impersonatingCompanyEmail: params.row.email,
      impersonatingadminName: params.row.adminName,
    };
    dispatch(postChildSwitchCompany(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0011") {
          localStorage.removeItem(process.env.REACT_APP_TEMP_TOKEN);
          localStorage.setItem(
            process.env.REACT_APP_ACCESS_TOKEN,
            "Bearer " + data.data.access_token
          );
          const decoded = jwt_decode(data.data.access_token);
          localStorage.setItem("companyId", decoded.companyId);
          localStorage.setItem("companyName", decoded.companyName);
          localStorage.setItem("companyType", decoded.companyType);
          localStorage.setItem("companyCode", decoded.companyCode);

          if (decoded.companyType === "PARTNER") {
            window.location.href = REACT_DASHBOARD_PANEL;
          }
        } else {
          Toast(data.message, "error");
        }
      });
  };

  const handleInvoice = (params) => {
    dispatch(getDealerInvoice(params))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4040") {
          setLoading(true);
          // downloadFile(res.data.receipt_url)
          window.open(res.data.receipt_url);
          Toast(t("RECEIPT_PDF"), "success");
          setLoading(false);
        } else {
          setLoading(false);
          Toast(t("dataTableEdit1"), "error");
        }
      })
      .catch((er) => { });
  };

  const ActionsCell = ({ row }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
    };

    return (
      <div>
        {/* Primary icons */}
        {/* <Tooltip title="View"> */}
        <IconButton onClick={() => handleView(row)}>
          <ViewIcon />
        </IconButton>
        {/* </Tooltip> */}
        {/* <Tooltip title="Edit"> */}
        <IconButton onClick={() => handleOpenEditDealer(row)}>
          <EditIcon />
        </IconButton>
        {/* </Tooltip> */}

        {/* Dropdown for overflow actions */}
        <IconButton onClick={handleMenuOpen}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={() => handleViewCustomer(row)}>
            <ListItemIcon>
              <CustomerIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="View Customer" />
          </MenuItem>
          <MenuItem onClick={() => handleImpersonation({ row })}>
            <ListItemIcon>
              <ImpersonationIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Impersonation" />
          </MenuItem>
          <MenuItem onClick={() => handleInvoice(row)}>
            <ListItemIcon>
              <InvoiceIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Receipt" />
          </MenuItem>
          <MenuItem onClick={() => handleResendAccountActivate(row)} style={{ marginTop: "-5px" }}>
            <ListItemIcon style={{ marginLeft: "-9px" }}>
              <ResendIcon fontSize="small" toolTip={true} />
            </ListItemIcon>
            <ListItemText style={{ marginLeft: "10px" }} primary="Resend Mail" />
          </MenuItem>
        </Menu>
      </div>
    );
  };
  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { name, imagePreSignedURL } = params.row;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${name?.charAt(0) || ""}`;
    const bgColor = !imagePreSignedURL
      ? getAvatarColor(initials)
      : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = imagePreSignedURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(
    () => [
      {
        field: "dealer.profile",
        headerName: "",
        sortable: false,
        width: 5,
        renderCell: (params) => {
          return ZoomHandaler(params);
        },
      },
      {
        field: "dealer.name",
        headerName: t("CUSTDATABLE01"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.name,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.name}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row.name)}</span>
          </Tooltip>
        ),
      },
      {
        field: "dealer.AdminName",
        headerName: t("CUSTDATABLE04"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.adminName,
      },
      {
        field: "dealer.email",
        headerName: t("CUSTDATABLE02"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.email,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.email}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row.email)}</span>
          </Tooltip>
        ),
      },
      {
        field: "dealer.phone",
        headerName: t("CUSTDATABLE03"),
        type: "singleSelect",
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.phone,
      },
      {
        field: "customerName",
        headerName: t("CUSTDATABLE21"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.customerName,
      },
      {
        field: "dealer.status",
        headerName: t("CUSTDATABLE07"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.status,
      },

      {
        field: "Actions",
        headerName: "Actions",
        type: "actions",
        flex: 1,
        minWidth: 150,
        width: 150,
        headerAlign: "center",
        renderCell: (params) => <ActionsCell row={params.row} />,
      },
    ],
    []
  );
  return (
    <>
      <HeaderToolbar title={t("DASHBOARDTABDEALER")} />

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item >
          <DealerFilter
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => applyFilter(data)}
          />
        </Box>

        <Box item>
          <ExportDialog
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleExportCustomer(data)}
            totalRecords={totalRecords}
            nameTitle={"Export Dealer"}
            handleFileFormatChange={handleFileFormatChange}
            handleDataRecordsChange={handleDataRecordsChange}
            handleInputChange={handleInputChange}
            handleToInputChange={handleToInputChange}
            fileFormat={fileFormat}
            noOfRecords={noOfRecords}
            inputValue={inputValue}
            toInputValue={toInputValue}
            setFileFormat={setFileFormat}
            setNoOfRecords={setNoOfRecords}
            setInputValue={setInputValue}
            setToInputValue={setToInputValue}
            setIsLivePhoto={setIsLivePhoto}
            setIsSignature={setIsSignature}
            isLivePhoto={isLivePhoto}
            isSignature={isSignature}
            handleCheckBoxLivePhoto={handleCheckBoxLivePhoto}
            handleCheckBoxSignature={handleCheckBoxSignature}
            dealerPortal={true}
            closemodel={closemodel}
            setClosemodel={setClosemodel}
          />
        </Box>

        <Tooltip title={t("ADDDEALER")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>

        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          rowId={(row) => row.id}
          handleChange={(newPage, size) => handleChange(newPage, size)}
          onSelectedRoles={(rows) => onSelectionChange(rows)}
        />
      </div>

      {openEditDealer && (
        <CreateDealer
          selectedObject={selectedObject}
          open={openEditDealer}
          handleClose={() => {
            handleClose(loadData(page, rowsPerPage));
          }}
        />
      )}

      {openDeleteDealer && (
        <DeleteDealer
          open={openDeleteDealer}
          handleDialogClose={handleClose}
          loadData={() => {
            loadData(filter, paging);
          }}
          handleClose={(data) => {
            setOpenDeleteDealer(data);
          }}
          dealerId={dealerId}
          dealerName={dealerName}
          dealer={dealer}
        />
      )}
    </>
  );
}
